import { supabase } from './supabase';

export async function updateSectionLocation(section: string, newLocation: 'loop' | 'tools') {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.user?.id) throw new Error('Not authenticated');

  const userId = session.user.id;

  const { data: customization } = await supabase
    .from('customizations')
    .select('section_locations')
    .eq('user_id', userId)
    .single();

  if (!customization) throw new Error('No customization found');

  const updated = {
    ...customization.section_locations,
    [section]: newLocation
  };

  const { error } = await supabase
    .from('customizations')
    .update({ section_locations: updated })
    .eq('user_id', userId);

  if (error) throw new Error(error.message);
  
  return { success: true };
}